import { Card } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const SummaryContainer = styled(Card) `
  grid-auto-flow: column;
  align-items: center;
  display: grid;
  padding: 0 1rem;
  flex: 1;
`;
export const SummaryLabel = styled.p `
  color: ${theme.palette.text.secondary};
`;
export const SummaryAmount = styled.p `
  overflow-wrap: ${(props) => (props.breakWord ? 'break-word' : '')};
  text-align: ${(props) => props.align || 'right'};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 0 0.5rem;
`;
